import React from "react";
import Advisory from "../Images/advisory.png";
import Corporate from "../Images/corporate.png";
import Honeymoon from "../Images/honeymoon.png";
import Leisure from "../Images/leisure.png";
import Wedding from "../Images/wedding.png";
import Business from "../Images/business.png";
import Passport from "../Images/passport.png";
import Visa from "../Images/visa.png";
import Exchange from "../Images/exchange.png";
import Insurance from "../Images/insurance.png";
import Car from "../Images/car.png";

const ServicesSection = [
  {
    title: "TRAVEL ADVISORY",
    description:
      "Our expert consultants offer personalized travel advice, helping you plan, optimize, and elevate every journey from choosing destinations to securing the best travel options.",
    image: Advisory,
  },
  {
    title: "CORPORATE TRAVEL (INTERNATIONAL AND DOMESTIC)",
    description:
      "Efficient, tailored travel solutions for businesses, ensuring seamless coordination, premium services, and cost-effective itineraries for both domestic and international work trips.",
    image: Corporate,
  },
  {
    title: "HONEYMOON PLANNING",
    description:
      "We curate unforgettable honeymoon experiences, combining romance, luxury, and unique destinations to make your first journey truly magical.",
    image: Honeymoon,
  },
  {
    title: "LEISURE PACKAGES",
    description:
      "Relax and explore with our custom leisure packages, crafted to match your pace and preferences—from beach escapes to cultural adventures.",
    image: Leisure,
  },
  {
    title: "DESTINATION WEDDING MANAGEMENT",
    description:
      "Celebrate your big day at the destination of your dreams, with our team handling every detail from logistics to luxury, making your wedding stress-free and spectacular.",
    image: Wedding,
  },
  {
    title: "BUSINESS HOTEL RESERVATIONS",
    description:
      "Access a global network of premium business hotels at corporate rates, with our assistance ensuring efficient bookings and high comfort.",
    image: Business,
  },
  {
    title: "PASSPORT FACILITATION SERVICES",
    description:
      "We streamline your passport application or renewal process with professional guidance and prompt service, saving you time and hassle.",
    image: Passport,
  },
  {
    title: "VISA FACILITATION & CONSULAR SERVICES",
    description:
      "Our visa experts assist with documentation, appointment scheduling, and follow-ups to ensure smooth processing for your travel requirements.",
    image: Visa,
  },
  {
    title: "FOREING EXCHANGE",
    description:
      "Get competitive exchange rates and secure currency services, whether for business or leisure travel, delivered with trust and transparency.",
    image: Exchange,
  },
  {
    title: "TRAVEL INSURANCE",
    description:
      "Travel with peace of mind through comprehensive insurance plans that protect you against unexpected delays, emergencies, or medical issues.",
    image: Insurance,
  },
  {
    title: "CAR RENTALS & CRUISE OPTIONS",
    description:
      "From chauffeur-driven rides to luxury cruise holidays, we offer mobility and indulgence to suit every mood and destination.",
    image: Car,
  },
];

const Services = () => {
  return (
    <div className="flex h-[calc(100vh-55px)] flex-col md:flex-row">
      {/* Mobile Top Heading */}
      <div className="md:hidden w-full py-6 flex justify-center">
        <h2 className="text-4xl font-copperplate tracking-wider leading-none bg-[hueShift_7s_linear_infinite] bg-clip-text text-transparent animate-[hueShift_7s_linear_infinite]">
          OUR SERVICES
        </h2>
      </div>

      {/* Sticky Left Sidebar (Desktop only) */}
      <div className="hidden md:flex w-[100px] flex-shrink-0 sticky top-[55px] h-[calc(100vh-55px)] items-center justify-center bg-[#fdf9f6] z-10 animate-[hueShift_7s_linear_infinite]">
        <h2 className="transform -rotate-90 text-[85px] text-[#FAE9B1] font-copperplate tracking-wider leading-none whitespace-nowrap">
          OUR SERVICES
        </h2>
      </div>

      {/* Scrollable Right Content */}
      <div className="flex-1 overflow-y-scroll px-6 md:px-10 py-10 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          {ServicesSection.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center space-y-4"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-[140px] h-[100px] object-contain"
              />
              <h3 className="font-bold text-lg text-[#5F4B8B]">
                {service.title}
              </h3>
              <p className="text-sm text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
